import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'sendButtonForShowingSliders', // This is the button which opens the sliders for actually sending the document.
  ]

  clickSendButtonForShowingSliders(e) {
    if (e.target == this.sendButtonForShowingSlidersTarget && (this.sendButtonForShowingSlidersTarget.ariaDisabled == 'false' || this.sendButtonForShowingSlidersTarget.ariaDisabled == null)) {
      this.sendButtonForShowingSlidersTarget.setAttribute('aria-disabled', 'true')
      this.sendButtonForShowingSlidersTarget.classList.add("pointer-events-none")
    }
    else if (this.sendButtonForShowingSlidersTarget.ariaDisabled == 'true') {
      this.sendButtonForShowingSlidersTarget.setAttribute('aria-disabled', 'false')
      this.sendButtonForShowingSlidersTarget.classList.remove("pointer-events-none")
    }
  }
}
